import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAutomations } from "./hooks/useAutomations";
import AutomationSidebar from "./components/AutomationSidebar";
import AutomationDetail from "./components/AutomationDetail";
import { MasterDetailLayout, ContentLoader, EmptyState, Breadcrumb } from "../../../components/Common";
import { AUTOMATION_CATEGORIES } from "../../../models/automation";

/**
 * AutomationsPage
 * Rota: /settings/automations
 * Layout Master-Detail: Sidebar com categorias + Painel com tabs por gatilho.
 */
const AutomationsPage = () => {
    document.title = "Automações | NeoApp";

    const navigate = useNavigate();
    const [activeCategoryId, setActiveCategoryId] = useState(AUTOMATION_CATEGORIES[0]?.id || "");

    const {
        mergedTriggers,
        isLoading,
        isSaving,
        handleToggleActive,
        handleSave,
        isIntegrated,
        isReady,
    } = useAutomations();

    if (!isReady) {
        return <ContentLoader message="Carregando Automações..." />;
    }

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Automações" />
            </div>

            <div className="border-top mb-3"></div>

            {!isIntegrated ? (
                <div className="border-0 rounded-0 p-4 text-center bg-white">
                    <EmptyState
                        icon="mdi mdi-whatsapp"
                        title="Integração WhatsApp Necessária"
                        description="Para utilizar as automações de mensagens, você precisa configurar e ativar a integração com a Evolution API."
                        actionLabel="Ir para Integrações"
                        onAction={() => navigate("/settings/integrations")}
                    />
                </div>
            ) : (
                <MasterDetailLayout
                    master={
                        <AutomationSidebar
                            triggers={mergedTriggers}
                            activeCategoryId={activeCategoryId}
                            onSelectCategory={setActiveCategoryId}
                            loading={isLoading}
                        />
                    }
                    detail={
                        <AutomationDetail
                            triggers={mergedTriggers}
                            categoryId={activeCategoryId}
                            onToggleActive={handleToggleActive}
                            onSave={handleSave}
                            isSaving={isSaving}
                        />
                    }
                />
            )}
        </React.Fragment>
    );
};

export default AutomationsPage;
